"use strict";
// tslint:disable
// eslint-disable
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class UsersApi extends runtime.BaseAPI {
    /**
     * Add user
     */
    addUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.newUserDTO === null || requestParameters.newUserDTO === undefined)) {
                throw new runtime.RequiredError('newUserDTO', 'Required parameter requestParameters.newUserDTO was null or undefined when calling addUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/user`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.NewUserDTOToJSON(requestParameters.newUserDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.UserDTOFromJSON(jsonValue));
        });
    }
    /**
     * Add user
     */
    addUser(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.addUserRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get current user
     */
    currentUserRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/user/current`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.LoggedInUserDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get current user
     */
    currentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.currentUserRaw();
            return yield response.value();
        });
    }
    /**
     * saving external user registration details
     * external user self registration
     */
    externalUserSelfRegistrationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.externalUserSelfRegistrationDTO === null || requestParameters.externalUserSelfRegistrationDTO === undefined)) {
                throw new runtime.RequiredError('externalUserSelfRegistrationDTO', 'Required parameter requestParameters.externalUserSelfRegistrationDTO was null or undefined when calling externalUserSelfRegistration.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/externalization/externalUserSelfRegistration`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ExternalUserSelfRegistrationDTOToJSON(requestParameters.externalUserSelfRegistrationDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * saving external user registration details
     * external user self registration
     */
    externalUserSelfRegistration(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.externalUserSelfRegistrationRaw(requestParameters);
        });
    }
    /**
     * Find user using filter which is matching one of those fields givenName, familyName, isid. Search is case-insensitive
     */
    findInstanceShareUsersRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling findInstanceShareUsers.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling findInstanceShareUsers.');
            }
            const queryParameters = {};
            if (requestParameters.scenarioId !== undefined) {
                queryParameters['scenarioId'] = requestParameters.scenarioId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/user/search/modelUsers/{modelUuid}`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.UserAccessDTOFromJSON));
        });
    }
    /**
     * Find user using filter which is matching one of those fields givenName, familyName, isid. Search is case-insensitive
     */
    findInstanceShareUsers(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.findInstanceShareUsersRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Find user using filter which is matching one of those fields givenName, familyName, isid. Search is case-insensitive
     */
    findUsersRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.name === null || requestParameters.name === undefined)) {
                throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling findUsers.');
            }
            const queryParameters = {};
            if (requestParameters.name !== undefined) {
                queryParameters['name'] = requestParameters.name;
            }
            if (requestParameters.limit !== undefined) {
                queryParameters['limit'] = requestParameters.limit;
            }
            if (requestParameters.includeNpa !== undefined) {
                queryParameters['includeNpa'] = requestParameters.includeNpa;
            }
            if (requestParameters.includeUnenrolled !== undefined) {
                queryParameters['includeUnenrolled'] = requestParameters.includeUnenrolled;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/user/search`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.UserDTOFromJSON));
        });
    }
    /**
     * Find user using filter which is matching one of those fields givenName, familyName, isid. Search is case-insensitive
     */
    findUsers(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.findUsersRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * external user view details
     * external user details
     */
    getExternalUserDetailsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.userReviewDTO === null || requestParameters.userReviewDTO === undefined)) {
                throw new runtime.RequiredError('userReviewDTO', 'Required parameter requestParameters.userReviewDTO was null or undefined when calling getExternalUserDetails.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/externalization/externalUserViewDetails`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.UserReviewDTOToJSON(requestParameters.userReviewDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExternalUserViewDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * external user view details
     * external user details
     */
    getExternalUserDetails(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getExternalUserDetailsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * List all external users
     */
    getExternalUserListRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/user/externalUsers`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.ExUserRegistrationDetailsFromJSON));
        });
    }
    /**
     * List all external users
     */
    getExternalUserList() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getExternalUserListRaw();
            return yield response.value();
        });
    }
    /**
     * Get user information by ISID
     */
    getUserByIsidRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.userId === null || requestParameters.userId === undefined)) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling getUserByIsid.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/user/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.UserDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get user information by ISID
     */
    getUserByIsid(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserByIsidRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * List all users
     */
    getUserListRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/user`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.UserDTOFromJSON));
        });
    }
    /**
     * List all users
     */
    getUserList() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserListRaw();
            return yield response.value();
        });
    }
    /**
     * saving external user registration details
     * create new external user
     */
    saveExternalUserRegistrationDetailsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.externalUserRegistrationDTO === null || requestParameters.externalUserRegistrationDTO === undefined)) {
                throw new runtime.RequiredError('externalUserRegistrationDTO', 'Required parameter requestParameters.externalUserRegistrationDTO was null or undefined when calling saveExternalUserRegistrationDetails.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/externalization/registerNewUser`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ExternalUserRegistrationDTOToJSON(requestParameters.externalUserRegistrationDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * saving external user registration details
     * create new external user
     */
    saveExternalUserRegistrationDetails(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.saveExternalUserRegistrationDetailsRaw(requestParameters);
        });
    }
    /**
     * External user activation
     */
    setExternalUserActiveRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.userReviewDTO === null || requestParameters.userReviewDTO === undefined)) {
                throw new runtime.RequiredError('userReviewDTO', 'Required parameter requestParameters.userReviewDTO was null or undefined when calling setExternalUserActive.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/auth/registration/review/activate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.UserReviewDTOToJSON(requestParameters.userReviewDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * External user activation
     */
    setExternalUserActive(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setExternalUserActiveRaw(requestParameters);
        });
    }
    /**
     * External user deactivate
     */
    setExternalUserDeactivateRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.userReviewDTO === null || requestParameters.userReviewDTO === undefined)) {
                throw new runtime.RequiredError('userReviewDTO', 'Required parameter requestParameters.userReviewDTO was null or undefined when calling setExternalUserDeactivate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/auth/registration/review/deactivate`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.UserReviewDTOToJSON(requestParameters.userReviewDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * External user deactivate
     */
    setExternalUserDeactivate(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setExternalUserDeactivateRaw(requestParameters);
        });
    }
    /**
     * External user reject request
     */
    setExternalUserRejectRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.rejectRequestDTO === null || requestParameters.rejectRequestDTO === undefined)) {
                throw new runtime.RequiredError('rejectRequestDTO', 'Required parameter requestParameters.rejectRequestDTO was null or undefined when calling setExternalUserReject.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/auth/registration/review/reject`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RejectRequestDTOToJSON(requestParameters.rejectRequestDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * External user reject request
     */
    setExternalUserReject(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setExternalUserRejectRaw(requestParameters);
        });
    }
    /**
     * Set user account as active/inactive
     */
    setUserActiveRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.emailId === null || requestParameters.emailId === undefined)) {
                throw new runtime.RequiredError('emailId', 'Required parameter requestParameters.emailId was null or undefined when calling setUserActive.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.body === null || requestParameters.body === undefined)) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling setUserActive.');
            }
            const queryParameters = {};
            if (requestParameters.emailId !== undefined) {
                queryParameters['emailId'] = requestParameters.emailId;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/user/active`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set user account as active/inactive
     */
    setUserActive(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setUserActiveRaw(requestParameters);
        });
    }
    /**
     * Update user type
     */
    setUserTypeRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.userId === null || requestParameters.userId === undefined)) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling setUserType.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.userTypeJSONWrapper === null || requestParameters.userTypeJSONWrapper === undefined)) {
                throw new runtime.RequiredError('userTypeJSONWrapper', 'Required parameter requestParameters.userTypeJSONWrapper was null or undefined when calling setUserType.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/user/{userId}/userType`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.UserTypeJSONWrapperToJSON(requestParameters.userTypeJSONWrapper),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Update user type
     */
    setUserType(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setUserTypeRaw(requestParameters);
        });
    }
}
exports.UsersApi = UsersApi;
